export const transformTermsAndConditionsDto = dto => ({
  additionalActions: dto.additional_actions,
  canAgree: dto.can_agree,
  canSkip: dto.can_skip,
  canAccept: dto.can_accept,
  postAgreementUrl: dto.post_agreement_url,
  agreementsUrl: dto.agreements_url
});